import { Stack } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';

export default function TotalCard({total}) {

    let tv = total > 1000 ? 'body' : 'h4';

    return (
        <div><small>Total:</small> {total}</div>
    )

    // return (<Card sx={{ maxWidth: '110px', '&.MuiPaper-root': { color: 'white', background: blue[400]}}}>
    //        <CardContent>
    //         <Stack>
    //             <Typography gutterBottom variant="h6" component="div">
    //                 Total
    //             </Typography>
    //             <Typography gutterBottom  variant={tv} component="div">
    //                 {total}
    //             </Typography>
    //         </Stack>
    //        </CardContent>
    //     </Card>)
}
